// Where to send someone after they sign in: the page they asked for, but only
// if it is a plain path on this site. Anything else (another site, a script
// URL, a page that would send them straight back to sign in) answers null and
// the caller uses its default.
const MAX_LENGTH = 2000;
// Pages that are not a destination after signing in. Matched case-insensitively
// because the router matches paths that way.
const NOT_A_DESTINATION = ['/', '/login', '/plan-expired'];
const NOT_A_DESTINATION_PREFIXES = ['/invite/'];

// Control characters and whitespace (a loop, not a regex: lint forbids control characters in one).
const hasControlOrSpace = (s) => {
    for (const ch of s) {
        const code = ch.codePointAt(0);
        if (code <= 0x20 || code === 0x7f) return true;
    }
    return false;
};

export function safeNext(value) {
    if (typeof value !== 'string' || value.length === 0 || value.length > MAX_LENGTH) return null;
    if (value[0] !== '/' || value[1] === '/' || value[1] === '\\') return null;
    if (hasControlOrSpace(value)) return null;
    try {
        if (hasControlOrSpace(decodeURIComponent(value))) return null;
    } catch {
        return null; // malformed % escape
    }

    const path = value.split(/[?#]/)[0].toLowerCase().replace(/\/+$/, '') || '/';
    if (NOT_A_DESTINATION.includes(path)) return null;
    if (NOT_A_DESTINATION_PREFIXES.some(p => path.startsWith(p))) return null;
    return value;
}
